/**
 * Adjust currency string with matching symbol and conversion rate.
 * Only respected if current iso does not equal defaultIso.
 *
 * Depends on currency.js v2.0.4
 *
 * Usage:
 * 1. data-currency-adjuster
 *    Add this data-attribute to an element.
 *    This will try to create an currency object which defaults to EURO.
 *    Then tries to convert to current shop currency respecting exchange rate
 *    then output the result.
 *
 * 2. data-currency-adjuster-iso
 *    Add this data-attribute to an element.
 *    This will replace the default iso code with the current iso code.
 *
 * 3. data-currency-adjuster-symbol
 *    Add this data-attribute to an element.
 *    This will replace the default currency symbol with the current currency symbol.
 *    Might need to be extended to your needs.
 *
 *    data-currency-adjuster-symbol-remove and data-currency-adjuster-iso-remove
 *    Add these data-attributes to an element.
 *    These will simply remove the symbol / iso code if found.
 *
 *  These attributes work independly from each other or on top of each other in the following order:
 *  - data-currency-adjuster-symbol with data-currency-adjuster-symbol-remove
 *  - data-currency-adjuster-iso with data-currency-adjuster-iso-remove
 *  - data-currency-adjuster
 */
document.addEventListener('DOMContentLoaded', function() {
  const defaultIso = 'EUR';
  const defaultSymbol = '€';
  const defaultSeparator = ' ';
  const defaultDecimal = ',';

  var iso = Shopify.currency.active;
  var symbol = Shopify.currency.active;
  var rate = Shopify.currency.rate;
  var adjustment = 0;

  if (!iso || defaultIso === iso) {
    return;
  }

  // pick symbol by iso
  switch (symbol) {
    case 'CHF': // some currencies do not have explicit symbols
      adjustment = 0.50;

      break;

    // add more symbols here if necessary
  }

  // symbol replacer
  const currencyAdjusterSymbol = document.querySelectorAll('[data-currency-adjuster-symbol]');
  currencyAdjusterSymbol.forEach(ele => {
    if (ele.dataset.hasOwnProperty('currencyAdjusterSymbolRemove')) {
      ele.innerHTML = ele.innerHTML.replaceAll(defaultSymbol, '');
    } else {
      ele.innerHTML = ele.innerHTML.replaceAll(defaultSymbol, symbol);
    }
  });

  // iso code replacer
  const currencyAdjusterIso = document.querySelectorAll('[data-currency-adjuster-iso]');
  currencyAdjusterIso.forEach(ele => {
    if (ele.dataset.hasOwnProperty('currencyAdjusterIsoRemove')) {
      ele.innerHTML = ele.innerHTML.replaceAll(defaultIso, '');
    } else {
      ele.innerHTML = ele.innerHTML.replaceAll(defaultIso, iso);
    }
  });

  // number replacer with exchange rate multiply
  const currencyAdjuster = document.querySelectorAll('[data-currency-adjuster]');
  currencyAdjuster.forEach(ele => {
    ele.innerHTML = ele.innerHTML.replace(/(\d+,\d*)/gm, ($1) => {
      let value = currency($1, {separator: defaultSeparator, decimal: defaultDecimal, symbol: defaultSymbol, pattern: `! #`});

      value = rate ? value.multiply(rate).multiply(1 + adjustment) : value;

      return value.format({separator: defaultSeparator, decimal: defaultDecimal, symbol: symbol});
    });
  });
});
